import { FunctionComponent, useState } from "react";
import { fetchGet, toQueryString } from "../../../service/api_client";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import StadiumButton from "../../../ui/new_components/common/stadium_button";
import LoadingWidget from "../../../ui/components/loading_spinner";

interface ExportStockOutwardProps {
  filter: {
    outward_type?: string[];
    outward_source?: string[];
    outward_date?: Date;
    warehouse?: string;
    outward_id?: string;
    order_id?: string;
    page: number;
    count: number;
    sort_order: string;
    all?: any;
    fromDate?: Date;
    toDate?: Date;
  };
}

const ExportStockOutward: FunctionComponent<ExportStockOutwardProps> = (
  props
) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/journal/stock_outward/export`;

  const getDetailedListData = async () => {
    const filter = props.filter;
    setLoading(true);
    try {
      // filter.fromDate = fromDate;
      // filter.toDate = toDate;
      const searchProp = { ...filter };
      searchProp.all = true;
      const res = await fetchGet(url + toQueryString(searchProp));
      if (res.success) {
        showToast({
          text: res.message,
          type: ToastType.success,
        });
      } else {
        console.log(res.error);
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  return (
    <div className="p-5">
      <div className="flex gap-4 justify-center my-4">
        <StadiumButton type="button" onTap={getDetailedListData}>
          Detailed Export
        </StadiumButton>
        {/* <StadiumButton type="button" onTap={getPOSummarisedListData}>
          Summarised Export
        </StadiumButton> */}
      </div>

      <LoadingWidget loading={loading} />
    </div>
  );
};

export default ExportStockOutward;
